import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/Layout"
import Title from "../components/Title"
import Seo from "../components/Seo"

const AboutUs = () => {
  return (
    <Layout>
      <Seo title="Nosotros" />
      <Container>
        <StaticImage
          className="img"
          src="../assets/images/about-hero.jpg"
          layout="fullWidth"
          alt="image"
        />
        <Title className="title-absolute" title="Nosotros" />
        <div className="about-center">
          <article>
            <h3>
              Empresa Loki Rent a Car es creada por un equipo de profesionales
              con el objetivo de entregar un servicio personalizado de calidad;
              brindando confianza, seriedad y sobretodo precios accesibles en la
              zona sur de Chile.
            </h3>

            <h3>
              Contamos con una gama de automóviles en excelentes condiciones,
              con mantenciones en cada entrega y chequeos semanales.
            </h3>
          </article>
        </div>
      </Container>
    </Layout>
  )
}

export default AboutUs

const Container = styled.div`
  color: var(--white);
  height: 100vh;
  position: relative;
  .img {
    height: 100%;
  }

  .about-center {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
  }
  article {
    margin-top: 50px;
    width: 85vw;
    max-width: 800px;
    text-align: center;
    h3 {
      font-size: 1.4rem;
      text-transform: none;
    }
  }

  @media (min-width: 768px) {
    h3 {
      font-size: 1.953rem;
    }
  }
`
